import { InstantAnswersConfig as IInstantAnswersConfig } from 'services/api-service'

export class InstantAnswersConfig implements IInstantAnswersConfig {
  constructor(config: IInstantAnswersConfig) {
    this.headingLevel = config.headingLevel || 2
    this.initialPageSize = config.initialPageSize
    this.pageSize = config.pageSize
    this.learnMoreEnabled = config.learnMoreEnabled
    this.multiItemQuestionEnabled = config.multiItemQuestionEnabled
    this.widgetDivId = config.widgetDivId
  }

  headingLevel: number
  initialPageSize: number
  pageSize: number
  learnMoreEnabled: boolean
  multiItemQuestionEnabled: boolean
  widgetDivId: string
}

let defaultConfig: IInstantAnswersConfig = {}
export function loadConfig(config: IInstantAnswersConfig): void {
  defaultConfig = new InstantAnswersConfig(config)
}
export { defaultConfig as default }
